'use client';

import useSWR from 'swr';
import { BREEDS_URL } from './constants';

export const useBreeds = () => {
  const { data } = useSWR(BREEDS_URL);
  return data;
};
